import skill from "./skill"
export default skill;
